(function() {
'use strict';

angular
    .module('TR')
    .controller('Shortlist', Shortlist);

function Shortlist(
                   $location,
                   $scope,
                   arrayUtil,
                   authService,
                   shortlistService,
                   urlUtils
) {
    const cm = this;

    cm.clearShortlist = clearShortlist;
    cm.loading = true;
    cm.remove = remove;
    cm.selectHotel = selectHotel;
    cm.shortlistFilter = shortlistFilter;
    cm.signIn = signIn;

    authService.bufferRoute(null);
    _loadList();
    $scope.$on('auth:signout', _loadList);

    function _loadList() {
        shortlistService.getHotelsInShortlist().then(function(sl) {
            if (sl) {
                cm.hotels = sl.Hotels;
                cm.id = sl.ShortlistId;
            }
            cm.loading = false;

            //to make maps work on desktop
            _.each(cm.hotels, h => {
                h.lat = h.Latitude;
                h.lon = h.Longitude;
            });
        });
    }

    function _contains(hotelObj, filter) {
        if (typeof hotelObj === 'string' && typeof filter === 'string') {
            return hotelObj.toLowerCase().indexOf(filter) > -1;
        }
        return true;
    }

    function remove(event, hotel) {
        event.preventDefault();
        event.stopPropagation();

        shortlistService.removeFromShortlist({
            Id: hotel.Id
        }).then(function() {
            const index = arrayUtil.indexOf(cm.hotels, function(h) {
                return h.Id === hotel.Id;
            });
            if (index >= 0) {
                cm.hotels.splice(index, 1);
            }
        });
    }


    function selectHotel(hotel) {
        $location.path(urlUtils.stripLeadingSlash(hotel.Url));
    }

    function clearShortlist() {
        shortlistService.clear(cm.id).then(function() {
            cm.hotels = [];
        });
    }

    function shortlistFilter(hotel) {
        return _contains(hotel.Name, cm.filter) || _contains(hotel.Location, cm.filter);
    }

    function signIn() {
        const url = 'shortlist';
        authService.bufferRoute(url);
        $location.url(`signin?cb=${encodeURIComponent(url)}`);
    }
}
})();
